import React from 'react'
import Main from 'layouts/main'
import { TabContent, TabPane } from 'reactstrap'
import { ApplicationState } from 'store'
import { CADASTRO_MODELO } from 'store/modules/backoffice/cadastroModelo/types'
import { useSelector } from 'react-redux'
import Search from './Tabs/Search'
import Register from './Tabs/Register'

const ChatWoot = () => {
  const { activeTab } = useSelector<ApplicationState, CADASTRO_MODELO>(
    (state) => state.cadastroModelo
  )
  return (
    <Main>
      <TabContent activeTab={activeTab}>
        <TabPane tabId="search">
          <Search />
        </TabPane>
        <TabPane tabId="register">
          <Register />
        </TabPane>
      </TabContent>
    </Main>
  )
}

export default ChatWoot
